// One application-wide modal host (components/layout/ModalHost.svelte). Replaces the vendored
// svelte-simple-modal: `modal.open(Component, props)` renders the component inside the host.

/** @typedef {{ closeButton?: boolean, closeOnEsc?: boolean, closeOnOuterClick?: boolean, class?: string, onClose?: () => void }} ModalOptions */

class ModalStore {
	/** @type {import('svelte').Component<any> | null} */
	component = $state.raw(null);
	/** @type {Record<string, unknown>} */
	props = $state.raw({});
	/** @type {ModalOptions} */
	options = $state.raw({});

	get isOpen() {
		return this.component !== null;
	}

	/**
	 * @param {import('svelte').Component<any>} component
	 * @param {Record<string, unknown>} [props]
	 * @param {ModalOptions} [options]
	 */
	open(component, props = {}, options = {}) {
		this.component = component;
		this.props = props;
		this.options = { closeButton: true, closeOnEsc: true, closeOnOuterClick: true, ...options };
	}

	close() {
		const onClose = this.options.onClose;
		this.component = null;
		this.props = {};
		this.options = {};
		onClose?.();
	}
}

export const modal = new ModalStore();
